import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { HighlightedTilesSection } from 'apps/promo/components/common/sections/highlighted-tiles-section/HighlightedTilesSection';
import { OverviewCardsSection } from 'apps/promo/components/common/sections/overview-cards-section/OverviewCardsSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import PromoIllustration from 'apps/promo/components/common/widgets/Illustration/PromoIllustration';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';

const TextContainer = styled.div`
    width: 100%;
    max-width: 815px;
    margin: 0 auto;

    p + p {
        margin-top: 1em;
    }
`;
const ImgContainer = styled.div`
    img {
        display: block;
        margin: 0 auto;
    }
`;

const StablecoinPage = (props) => {
    return (
        <PromoPageContainer bgColor="baseColor" noIndent>
            {props.heroTitle && <HeroSection title={props.heroTitle} text={props.heroText} img={props.heroImg} data={props.heroData} />}
            <ColoredSectionContainer>
                {(props.headline1Title || props.headline1Text) && (
                    <TextContainer>
                        <HeadingSection whiteTitle title={props.headline1Title} text={props.headline1Text} noTopIndent textLeft />
                    </TextContainer>
                )}
                {props.tiles && <TilesSection data={props.tiles} promoDarkPageNew lang={props.lang} country={props.country} />}
                {(props.headline2Title || props.headline2Text) && (
                    <HeadingSection whiteTitle title={props.headline2Title} text={props.headline2Text} noTopIndent noBottomIndent />
                )}
                {props.tiles2 && <TilesSection data={props.tiles2} promoDarkPageNew imgBottom titleH2 lang={props.lang} country={props.country} />}
                {(props.headline3Title || props.headline3Text) && (
                    <HeadingSection whiteTitle title={props.headline3Title} text={props.headline3Text} noTopIndent />
                )}
                {(props.overviewCardsSectionTitle || props.overviewCardsSectionText || props.overviewCardsSectionCards) && (
                    <OverviewCardsSection
                        title={props.overviewCardsSectionTitle}
                        text={props.overviewCardsSectionText}
                        data={props.overviewCardsSectionCards}
                        promoDarkPageNew
                    />
                )}
                {(props.headline4Title || props.headline4Text) && <HeadingSection whiteTitle title={props.headline4Title} text={props.headline4Text} />}
                {props.highLightedTiles && <HighlightedTilesSection promoDarkPage promoDarkPageNew data={props.highLightedTiles} />}
                {(props.headline5Title || props.headline5Text) && (
                    <HeadingSection whiteTitle title={props.headline5Title} text={props.headline5Text} noTopIndent />
                )}
            </ColoredSectionContainer>
            {props.img && (
                <ImgContainer>
                    <PromoIllustration img={props.img} loadingLazy={props.loadingLazy} />
                </ImgContainer>
            )}
            <ColoredSectionContainer noTopPadding>
                {props.tiles3 && <TilesSection data={props.tiles3} lang={props.lang} country={props.country} promoDarkPageNew alignCenter />}
                {(props.headline6Title || props.headline6Text) && (
                    <TextContainer>
                        <HeadingSection whiteTitle title={props.headline6Title} text={props.headline6Text} noTopIndent textLeft />
                    </TextContainer>
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        heroImg: state.extra?.strapiApi?.hero_block?.img,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        tiles: state.extra?.strapiApi?.tiles_section,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        tiles2: state.extra?.strapiApi?.tiles_section2,

        headline3Title: state.extra?.strapiApi?.headline3?.title,
        headline3Text: state.extra?.strapiApi?.headline3?.text,

        overviewCardsSectionTitle: state.extra?.strapiApi?.overview_cards_section?.title,
        overviewCardsSectionText: state.extra?.strapiApi?.overview_cards_section?.text,
        overviewCardsSectionCards: state.extra?.strapiApi?.overview_cards_section?.cards,

        headline4Title: state.extra?.strapiApi?.headline4?.title,
        headline4Text: state.extra?.strapiApi?.headline4?.text,

        highLightedTiles: state.extra?.strapiApi?.tiles_highlighted,

        headline5Title: state.extra?.strapiApi?.headline5?.title,
        headline5Text: state.extra?.strapiApi?.headline5?.text,

        img: state.extra?.strapiApi?.img,

        tiles3: state.extra?.strapiApi?.tiles_section3,

        headline6Title: state.extra?.strapiApi?.headline6?.title,
        headline6Text: state.extra?.strapiApi?.headline6?.text,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(StablecoinPage));
